import { motion } from "framer-motion";
import {
  Rocket,
  Smartphone,
  Search,
  ShoppingCart,
  PenTool,
  Headphones,
} from "lucide-react";

const services = [
  {
    icon: Rocket,
    title: "Lightning Fast Builds",
    desc: "Optimized code, smart caching, and a 90+ Lighthouse score baked in by default.",
  },
  {
    icon: Smartphone,
    title: "Mobile-First Design",
    desc: "Pixel-perfect, fully responsive layouts that feel native on every device.",
  },
  {
    icon: Search,
    title: "SEO That Ranks",
    desc: "On-page SEO, schema, sitemaps, and content structure built for Google.",
  },
  {
    icon: ShoppingCart,
    title: "E-Commerce Ready",
    desc: "Stripe, Shopify, WooCommerce — payment gateways integrated and tested.",
  },
  {
    icon: PenTool,
    title: "Bespoke Branding",
    desc: "Custom motion, typography, and color systems unique to your business.",
  },
  {
    icon: Headphones,
    title: "Real Human Support",
    desc: "We answer calls and messages. Monthly maintenance plans available.",
  },
];

export default function Services() {
  return (
    <section id="services" className="section-pad relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-10 mb-16">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="md:col-span-7"
          >
            <span className="font-mono-jb text-xs uppercase tracking-[0.3em] text-[#CCFF00]">
              / What we do
            </span>
            <h2 className="font-display text-4xl sm:text-5xl tracking-tight font-bold mt-4 leading-[1.05]">
              Everything you need to <br />
              <span className="text-gradient-neon">dominate online.</span>
            </h2>
          </motion.div>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="md:col-span-5 text-zinc-400 text-lg leading-relaxed self-end"
          >
            From the first sketch to the final launch — and every monthly
            update after. One team, full-stack execution.
          </motion.p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="bento-card p-8 group"
              data-testid={`service-card-${i}`}
            >
              <div className="w-12 h-12 rounded-xl bg-[#CCFF00]/10 border border-[#CCFF00]/30 flex items-center justify-center mb-6 group-hover:bg-[#CCFF00] group-hover:border-[#CCFF00] transition-colors">
                <s.icon className="w-6 h-6 text-[#CCFF00] group-hover:text-black transition-colors" />
              </div>
              <h3 className="font-display text-2xl font-bold mb-2">
                {s.title}
              </h3>
              <p className="text-zinc-400 leading-relaxed">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
